import React from 'react'
import { Field } from 'formik'
import Component from './Sort'

const Sort = () => <Field name='sortBy' component={Component} />

export { Sort }
